module.exports = __webpack_public_path__ + "img/immigration.68cc3c1b.png";